<template>
  <v-card class="mx-auto pa-0" rounded="xl" height="350" width="280" :color="customColor('cardColor')" @click="$emit('click')">
    <v-row justify="center">
      <v-img class="mt-n10 mb-4" height="128" width="128" :src="data.icon" contain></v-img>
    </v-row>
    <v-card-text>
      <v-row justify="center">
        <div class="ma-4 text-h6 text-truncate" :style="customColor('titleColor')">{{ data.name }}</div>
      </v-row>
      <p class="mx-2 my-4 multi-lines" :style="customColor('contentColor')">{{ data.description }}</p>
      <v-row class="mx-2 mt-4" justify="space-between">
        <v-rating
          :value="data.rating"
          :color="customColor('ratingColor')"
          :background-color="customColor('ratingColor')"
          dense
          half-increments
          readonly
          size="14"
        ></v-rating>
        <div v-if="!discount.exist" style="font-size: 14px" :style="customColor('priceColor')">NT${{ price(data.price) }}{{ unit(data.price) }}</div>
        <div v-else class="text-decoration-line-through" style="font-size: 14px" :style="customColor('priceColor')">
          NT${{ price(data.price) }}{{ unit(data.price) }}
        </div>
      </v-row>
      <v-row class="mx-2" v-show="discount.exist" justify="space-between">
        <div style="font-size: 14px" :style="customColor('discountColor')">{{ discountPeriod }}</div>
        <div style="font-size: 14px" :style="customColor('discountColor')">NT${{ price(discount.price) }}{{ unit(discount.price) }}</div>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Product from '../store/product';

export default {
  name: 'CardIntro',
  props: {
    data: { type: Object, required: true },
    styleInfo: {
      type: Object,
      default: () => ({
        cardColor: 'white',
        titleColor: '#737373',
        contentColor: '#737373',
        ratingColor: '#737373',
        priceColor: '#007EAE',
        discountColor: 'red',
      }),
    },
  },
  data: () => ({
    discount: {},
  }),
  computed: {
    discountPeriod() {
      return Product.discountPeriod();
    },
  },
  created() {
    this.discount = Product.discountProc(this.data.discountPeriod, this.data.discount);
  },
  methods: {
    customColor(type) {
      switch (type) {
        case 'cardColor':
        case 'ratingColor':
          return this.styleInfo[type];
        default:
          return `color: ${this.styleInfo[type]}`;
      }
    },
    price(price) {
      return Product.price(price);
    },
    unit(price) {
      return this.$t(Product.unit(price));
    },
  },
};
</script>

<style scoped>
.multi-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  white-space: normal;
  height: 110px;
}
</style>
